var _defs, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _line, _g2, _circle, _path8, _line2, _line3, _ellipse, _ellipse2, _line4, _line5, _path9, _path10, _path11, _path12, _path13, _path14, _polygon, _path15, _path16, _path17, _polygon2, _path18, _path19, _rect, _path20, _circle2, _path21, _path22, _ellipse3, _path23, _rect2, _path24, _line6, _rect3, _rect4, _g3, _rect5, _rect6, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHello(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a581a3db-2a43-4a80-ac9d-86c7ddaa56ac",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 903.82216,
    height: 748.21523,
    viewBox: "0 0 903.82216 748.21523",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fbde297d-ab9b-4106-ad77-f89466c8290f",
    x1: 963.63174,
    y1: 410.81483,
    x2: 963.63174,
    y2: 349.80222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53514,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b55aa966-9953-40ef-b933-2af4fb1d4bf9",
    x1: 514.09486,
    y1: 824.10762,
    x2: 514.09486,
    y2: 75.89238,
    xlinkHref: "#fbde297d-ab9b-4106-ad77-f89466c8290f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a395c18f-205e-4149-866b-9e6fd62c4f5f",
    x1: 725.6791,
    y1: 487.07514,
    x2: 725.6791,
    y2: 484.07514,
    xlinkHref: "#fbde297d-ab9b-4106-ad77-f89466c8290f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bfa05cfc-d7ec-49e0-8f8e-7dcb2e2661be",
    x1: 647.53882,
    y1: 341.17819,
    x2: 647.53882,
    y2: 183.07696,
    xlinkHref: "#fbde297d-ab9b-4106-ad77-f89466c8290f"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Hello") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M287.07624,677.78716c0,45.23881-26.89446,61.0365-60.06793,61.0365-.77234,0-1.54052-.00836-2.3045-.02923-1.53635-.0334-3.06018-.10019-4.56313-.20874-29.94213-2.11666-53.20445-18.72843-53.20445-60.79853,0-43.53546,55.62587-98.47249,59.8216-102.55134l.00836-.00418c.15865-.15862.24212-.23794.24212-.23794S287.07624,632.54417,287.07624,677.78716Z",
    transform: "translate(-149.80335 -75.89238)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M224.81651,731.90173,246.78882,701.204l-22.02658,34.06687-.05843,3.52358c-1.53635-.0334-3.06018-.10019-4.56313-.20874l2.36714-45.25968-.01671-.3507.04176-.06678.22126-4.27508L200.6733,654.47889l22.14764,30.94826.05427.906,1.791-34.19632-18.90376-35.2901,19.13337,29.28247,1.862-70.89335.00836-.24212v.23794l-.309,55.90561,18.81611-22.16436-18.89543,26.978-.49679,30.61846,17.572-29.38269L225.806,671.07815l-.27553,17.02093,25.5084-40.90115-25.60441,46.842Z",
    transform: "translate(-149.80335 -75.89238)",
    fill: "#f2f2f2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M983.78769,360.69733V349.80222H929.31215V400.1921a10.62275,10.62275,0,0,0,10.62273,10.62273H973.165a10.62275,10.62275,0,0,0,10.62273-10.62273V389.02461a14.16364,14.16364,0,0,0,0-28.32728Zm0,22.87973V366.14489a8.71608,8.71608,0,1,1,0,17.43217Z",
    transform: "translate(-149.80335 -75.89238)",
    fill: "url(#fbde297d-ab9b-4106-ad77-f89466c8290f)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M982.035,362.40265a12.932,12.932,0,1,0,12.932,12.932A12.932,12.932,0,0,0,982.035,362.40265Zm0,20.89019a7.95817,7.95817,0,1,1,7.95817-7.95817A7.95817,7.95817,0,0,1,982.035,383.29284Z",
    transform: "translate(-149.80335 -75.89238)",
    fill: "#facc1d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M982.035,362.40265a12.932,12.932,0,1,0,12.932,12.932A12.932,12.932,0,0,0,982.035,362.40265Zm0,20.89019a7.95817,7.95817,0,1,1,7.95817-7.95817A7.95817,7.95817,0,0,1,982.035,383.29284Z",
    transform: "translate(-149.80335 -75.89238)",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M782.49312,276.56256h49.73854a0,0,0,0,1,0,0v45.95716a9.75,9.75,0,0,1-9.75,9.75H792.24312a9.75,9.75,0,0,1-9.75-9.75V276.56256A0,0,0,0,1,782.49312,276.56256Z",
    fill: "#facc1d"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M973.08206,352.455v46.00814a9.699,9.699,0,0,1-9.699,9.699h4.97385a9.699,9.699,0,0,0,9.699-9.699V352.455Z",
    transform: "translate(-149.80335 -75.89238)",
    opacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M942.11171,315.37321a2.90423,2.90423,0,0,0-2.19651,1.11521c-.65244,1.18276.52985,2.51633,1.60877,3.329,1.99325,1.50147,4.09411,2.97632,5.449,5.072s1.78051,5.02022.29944,7.02867c-1.93388,2.62249-6.5477,3.18662-6.99421,6.4143-.28666,2.07216,1.50474,3.8403,3.31991,4.88008,4.48026,2.5664,10.25592,3.25107,13.50114,7.267,1.34248-2.76054,4.34522-4.35628,7.33829-5.03772s6.10288-.63057,9.13754-1.09285a3.15942,3.15942,0,0,0,2.52119-1.33731c.8483-1.72159-1.56944-3.78639-.735-5.51473.63511-1.31546,2.50083-1.2133,3.86328-1.74011,2.21844-.85777,3.13326-3.71287,2.50362-6.00651s-2.40819-4.08614-4.27841-5.55575c-5.0403-3.96061-11.10094-6.28982-17.23091-7.96517-2.851-.7792-6.19776-2.00112-9.159-2.11925C948.20129,313.996,944.94105,314.88918,942.11171,315.37321Z",
    transform: "translate(-149.80335 -75.89238)",
    fill: "#eee"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 443.20908,
    y1: 344.01609,
    x2: 339.20908,
    y2: 668.01609,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M673.59135,780.39881c-12.7927.74179-24.18945,11.45861-24.18945,11.45861l-5.51071-13.67007-.45.14631c2.69215-11.78463,57.46619-254.71944,2.63435-275.66276-42.13333-16.093-86.8238-36.008-121.83818-35.25969V410.02179h49.08874v-2.04536H612.188c7.44972-5.32121-3.375-8.98043-15.47324-11.26729a11.05637,11.05637,0,0,0,1.29657-1.82921L660.2541,283.20921s14.31755-23.52169,5.11341-34.77119-22.499,28.6351-22.499,28.6351L591.7344,350.70623s-51.60868-53.79049-84.43918-80.541a57.46883,57.46883,0,0,0-12.22144-9.23685c-5.993-4.05458-10.52937-6.15544-12.76636-5.33156-.0231.00849-.04114.02234-.06386.03127a57.28712,57.28712,0,0,0-15.27637-2.07664h-4.09073v-8.39106a65.60833,65.60833,0,0,0,40.5264-38.40126,73.69511,73.69511,0,0,0,5.83991-64.168,4.25825,4.25825,0,0,0,1.72234-.59629c1.85211-1.19228,2.03532-3.80048,1.85667-5.9959A45.55549,45.55549,0,0,0,489.699,100.38013c-5.18151-2.83335-11.1158-4.78552-14.93662-9.28853-3.28315-3.86932-4.66281-9.281-8.63562-12.43809-4.71992-3.75067-11.538-3.10588-17.32967-1.43228a63.05826,63.05826,0,0,0-18.08788,8.53556c-6.2648,4.29072-11.91858,9.80312-19.13085,12.17806-5.12464,1.68751-10.68242,1.65386-15.83958,3.2392A26.60455,26.60455,0,0,0,378.6221,117.8681a34.75071,34.75071,0,0,0-1.4643,13.04831,73.21928,73.21928,0,0,0-7.346,16.71183c-.38581.20842-.77394.41235-1.1562.62726l1.12125-.50423a73.61747,73.61747,0,0,0,20.742,75.089,65.55221,65.55221,0,0,0,31.4504,22.32011V255.3116a77.33331,77.33331,0,0,0-25.09984,10.27975l-.01092-.01348s-.65272.40392-1.7701,1.15532q-.16806.11283-.33531.22653c-7.56756,5.13613-32.9257,23.90319-32.0693,44.18275q-.05,1.16924.01329,2.34628a77.97484,77.97484,0,0,0-2.08874,17.88327V478.54149a72.27509,72.27509,0,0,0,15.51138,44.8263c-21.34143,4.78327-34.94234,12.0177-34.94234,20.114a6.55,6.55,0,0,1,0,2.04536c0,14.40269,43.03978,26.07839,96.13211,26.07839,6.41929,0,12.68959-.17215,18.75665-.49773l59.98988,48.56379-96.13212,154.425S388.22066,798.641,412.765,806.82245,487.42083,821.14,487.42083,821.14s8.18145-14.31755-3.06805-20.45365-26.58973-3.068-26.58973-3.068l2.04536-12.27219s166.69718-143.17549,131.926-192.26423c-6.65218-9.39127-13.30454-19.08147-20.014-28.62049l26.24156,2.39148,5.97143,224.757.74691-.24318c-1.49894,4.41531-12.10128,37.73967,11.39931,32.10025,25.15783-6.037,70.93278-27.33159,70.93278-27.33159S686.384,779.65708,673.59135,780.39881ZM573.32612,393.65888l-49.08874-14.25157V337.41136l53.35375,56.63708C574.968,393.7854,573.32612,393.65888,573.32612,393.65888Z",
    transform: "translate(-149.80335 -75.89238)",
    fill: "url(#b55aa966-9953-40ef-b933-2af4fb1d4bf9)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 292.20908,
    cy: 99.01609,
    r: 72
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M524.01243,339.90847,578.95956,398.237a10.735,10.735,0,0,0,17.19064-2.13449l60.86223-109.194-17-6-50,72s-93.86722-97.83676-107-93S524.01243,339.90847,524.01243,339.90847Z",
    transform: "translate(-149.80335 -75.89238)",
    fill: "#facc1d"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 269.20908,
    y1: 466.01609,
    x2: 188.20908,
    y2: 676.01609,
    fill: "none",
    stroke: "#bdbdbd",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 309.20908,
    y1: 466.01609,
    x2: 390.20908,
    y2: 676.01609,
    fill: "none",
    stroke: "#bdbdbd",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 289.20908,
    cy: 467.51609,
    rx: 94,
    ry: 25.5,
    fill: "#b84733"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 289.20908,
    cy: 465.51609,
    rx: 94,
    ry: 25.5,
    fill: "#f55f44"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 249.65524,
    y1: 512.15438,
    x2: 338.34537,
    y2: 539.48372,
    fill: "none",
    stroke: "#bdbdbd",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 328.76293,
    y1: 512.15438,
    x2: 240.0728,
    y2: 539.48372,
    fill: "none",
    stroke: "#bdbdbd",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M290.30373,182.01609h27.90535a56,56,0,0,1,56,56v148a0,0,0,0,1,0,0h-160a0,0,0,0,1,0,0V258.11073A76.09465,76.09465,0,0,1,290.30373,182.01609Z",
    fill: "#facc1d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M214.20908,386.01609h160a0,0,0,0,1,0,0v87a0,0,0,0,1,0,0h-89a71,71,0,0,1-71-71v-16A0,0,0,0,1,214.20908,386.01609Z",
    fill: "#39447a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M366.17338,317.94774l97.839,92.96073h108v-14l-93-27L399.45858,271.6682S363.33432,293.987,366.17338,317.94774Z",
    transform: "translate(-149.80335 -75.89238)",
    opacity: 0.05
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M366.17338,315.94774l97.839,92.96073h108v-14l-93-27L399.45858,269.6682S363.33432,291.987,366.17338,315.94774Z",
    transform: "translate(-149.80335 -75.89238)",
    fill: "#facc1d"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M572.01243,394.90847s52,4,38,14h-38Z",
    transform: "translate(-149.80335 -75.89238)",
    fill: "#fda57d"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M640.01243,280.90847s13-39,22-28-5,34-5,34Z",
    transform: "translate(-149.80335 -75.89238)",
    fill: "#fda57d"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "214.209 386.016 214.209 390.683 374.209 391.016 374.209 386.016 214.209 386.016",
    opacity: 0.05
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M488.4746,554.45287l107.62728,9.80835,5.839,219.77206L640.472,771.48922s57.6262-248.99812,2.67632-269.98649-114.34827-48.62584-149.81213-26.10219S488.4746,554.45287,488.4746,554.45287Z",
    transform: "translate(-149.80335 -75.89238)",
    fill: "#39447a"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M495.01243,486.90847s59,30,67,64",
    transform: "translate(-149.80335 -75.89238)",
    opacity: 0.1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M432.01341,547.90847l83.999,68-94,151,39,11s163-140,129-188-68-104-110-105S432.01341,547.90847,432.01341,547.90847Z",
    transform: "translate(-149.80335 -75.89238)",
    fill: "#39447a"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "414.209 251.016 435.209 287.016 440.209 277.016 414.209 251.016",
    opacity: 0.05
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M422.01243,766.90847s-31,24-7,32,73,14,73,14,8-14-3-20-26-3-26-3l2-12Z",
    transform: "translate(-149.80335 -75.89238)",
    fill: "#333"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M602.83492,783.32322s-13.617,37.76379,10.98282,31.86062,69.35958-26.72544,69.35958-26.72544-.61451-16.1128-13.12346-15.38749-23.65292,11.20443-23.65292,11.20443l-5.38851-13.36687Z",
    transform: "translate(-149.80335 -75.89238)",
    fill: "#333"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 274.20908,
    y: 147.01609,
    width: 40,
    height: 60,
    rx: 19.99998,
    fill: "#fda57d"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M444.01243,224.90847a20,20,0,0,0-20,19.99994v6.7951a64.00575,64.00575,0,0,0,40,0v-6.7951A20,20,0,0,0,444.01243,224.90847Z",
    transform: "translate(-149.80335 -75.89238)",
    opacity: 0.05
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 294.20908,
    cy: 113.01609,
    r: 64,
    fill: "#fda57d"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M380.01243,186.00437s16,4.12326,25-14.0616,16-28.10386,53-17.35826,44.44319,12.05663,46.2216,1.89539c1.21524-6.94351-11.94134-23.80913-20.39569-33.79439-4.12437-4.8712-10.85474-7.777-18.04778-7.777H424.01243l-25,11.57218-19,16.53168-4,22.31777Z",
    transform: "translate(-149.80335 -75.89238)",
    opacity: 0.05
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M380.01243,184.00437s16,4.12326,25-14.0616,16-28.10386,53-17.35826,44.44319,12.05663,46.2216,1.89539c1.21524-6.94351-11.94134-23.80913-20.39569-33.79439-4.12437-4.8712-10.85474-7.777-18.04778-7.777H424.01243l-25,11.57218-19,16.53168-4,22.31777Z",
    transform: "translate(-149.80335 -75.89238)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 236.70908,
    cy: 108.01609,
    rx: 6.5,
    ry: 13,
    fill: "#fda57d"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M381.86673,150.45773c-1.48322-8.37131-2.94041-17.16183-.24-25.22325a26.01449,26.01449,0,0,1,16.737-16.32379c5.04277-1.55019,10.47728-1.51725,15.48824-3.16734,7.05234-2.32232,12.58072-7.71241,18.70655-11.908a61.65817,61.65817,0,0,1,17.68674-8.34627c5.66325-1.63651,12.33009-2.267,16.94527,1.40053,3.88476,3.08706,5.23381,8.37868,8.44414,12.1622,3.73606,4.40314,9.53875,6.312,14.6053,9.08256a44.54492,44.54492,0,0,1,22.61,34.82874c.17469,2.14674-.00446,4.69713-1.81551,5.86294a6.483,6.483,0,0,1-3.64722.66575c-25.57863-.36557-51.188-.73272-76.66129-3.08081-7.91886-.73-15.8534-1.65222-23.80013-1.35115a77.85459,77.85459,0,0,0-35.04458,9.888",
    transform: "translate(-149.80335 -75.89238)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 645.26708,
    width: 154.0855,
    height: 65.5683,
    rx: 32.78412,
    fill: "#facc1d"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M725.6791,487.07514a1.5009,1.5009,0,0,0,0-3,1.5009,1.5009,0,0,0,0,3Z",
    transform: "translate(-149.80335 -75.89238)",
    fill: "url(#a395c18f-205e-4149-866b-9e6fd62c4f5f)"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 795.97132,
    y1: 344.01609,
    x2: 899.97132,
    y2: 714.10762,
    fill: "none",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 338.7871,
    y: 333.17819,
    width: 561.6062,
    height: 21.88496,
    fill: "#e0e0e0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 477.20908,
    y: 328.01609,
    width: 92,
    height: 13,
    rx: 6.49999,
    fill: "#535461"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 533.20908,
    y: 183.07696,
    width: 228.65948,
    height: 158.10123,
    rx: 28.21956,
    fill: "url(#bfa05cfc-d7ec-49e0-8f8e-7dcb2e2661be)"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 537.2857,
    y: 185.99396,
    width: 216.60901,
    height: 155.18423,
    rx: 26.83505,
    fill: "#3e3f49"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 540.2857,
    y: 185.99396,
    width: 216.60901,
    height: 155.18423,
    rx: 26.83505,
    fill: "#535461"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 658.70908,
    cy: 262.51609,
    r: 7,
    fill: "#e0e0e0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHello);
export default __webpack_public_path__ + "static/media/hello.4a9307f436a107a4b8083e617722bb54.svg";
export { ForwardRef as ReactComponent };